import Link from 'next/link';
import { FC } from 'react';
import { render } from 'storyblok-rich-text-react-renderer-ts';

import { GlossaryItem } from '../../types/Glossary';
import { getFirstStoryblokParagraph } from '../../utils/renderStoryblokRichText';

interface Props {
  item: GlossaryItem;
  onClick: () => void;
}

export const GlossaryListItem: FC<Props> = ({ item, onClick }) => (
  <Link
    className="flex flex-col transition-colors duration-300 hover:text-neutral-4"
    href={item.href}
    onClick={onClick}
  >
    <h3 className="font-bold">{item.title}</h3>
    {render(getFirstStoryblokParagraph(item.description))}
  </Link>
);
